import type { InitOptions } from 'i18next';
import type { DetectorOptions } from 'i18next-browser-languagedetector';
import type { HttpBackendOptions } from 'i18next-http-backend';

// Mezcla de opciones del core + backend + detector
type I18nOptions = InitOptions<HttpBackendOptions> & {
  detection?: DetectorOptions;
};

const i18nConfig: I18nOptions = {
  fallbackLng: 'es',
  supportedLngs: ['es', 'en'],

  backend: {
    // Con tu estructura: /public/locales/<lng>/<lng>.json -> /locales/<lng>/<lng>.json
    loadPath: '/locales/{{lng}}/{{lng}}.json',
  },

  // Importante: literal reconocido por el tipo (no como string genérico)
  load: 'languageOnly',

  interpolation: { escapeValue: false },

  detection: {
    order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
    caches: ['localStorage'],
    lookupQuerystring: 'lng',
    htmlTag:
      typeof document !== 'undefined' ? document.documentElement : undefined,
  },
};

export default i18nConfig;
